const prodsActionTypes = {
  REDIRECT_TO_SINGLE_PROD: 'REDIRECT_TO_SINGLE_PROD',
  FILTER_WITH_SEARCH_TERM: 'FILTER_WITH_SEARCH_TERM',
};

export default prodsActionTypes;
